import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'RemoveGenderAndRace' })
export class RemoveGenderAndRace implements PipeTransform {
  transform(value: string): string {
    const newStr = value.replace(/(Ethnic|Eth|White|Wht|Male|Female)/g, '');
    return newStr;
  }
}
